import { useContext, useMemo } from 'react';
import { I13nContext } from 'react-i13n';

import createI13nUtils, { type I13nUtils } from 'Lib/i13n/createI13nUtils';

/**
 * A hook for using i13n utils inside React.
 *
 * See docs/Instrumentation.md for more information.
 * Please use getI13nUtils from src/client/lib/i13nUtils.ts outside of React.
 */
const useI13n = (): I13nUtils => {
  const { executeEvent } = useContext(I13nContext);
  const utils = useMemo(() => createI13nUtils(executeEvent), [executeEvent]);
  return utils;
};

export default useI13n;
